// Reference data for the investor profile. Kept as plain data so the onboarding and settings
// screens stay thin.

export const COUNTRIES = [
  'Portugal', 'Spain', 'France', 'Germany', 'Italy', 'Netherlands', 'Belgium', 'Luxembourg',
  'Ireland', 'United Kingdom', 'Switzerland', 'Austria', 'Denmark', 'Sweden', 'Norway', 'Finland',
  'Poland', 'Czechia', 'Greece', 'Romania', 'Hungary', 'Croatia', 'Bulgaria', 'Slovakia',
  'Slovenia', 'Estonia', 'Latvia', 'Lithuania', 'Malta', 'Cyprus', 'Iceland',
  'United States', 'Canada', 'Mexico', 'Brazil', 'Argentina', 'Chile', 'Colombia', 'Uruguay',
  'Angola', 'Mozambique', 'Cape Verde', 'South Africa', 'Morocco', 'Nigeria', 'Kenya', 'Egypt',
  'United Arab Emirates', 'Saudi Arabia', 'Qatar', 'Israel', 'Turkey',
  'India', 'China', 'Hong Kong', 'Singapore', 'Japan', 'South Korea', 'Indonesia', 'Thailand',
  'Australia', 'New Zealand', 'Other',
];

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'pt', label: 'Português' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' },
];

export const PROFESSIONAL_BACKGROUNDS = [
  'Entrepreneur / Business Owner',
  'Executive / Management',
  'Finance / Investment',
  'Technology',
  'Real Estate',
  'Professional Services',
  'Student',
  'Retired',
  'Other',
  'Prefer not to say',
];

export const ORGANIZATION_TYPES = [
  'Investment Company',
  'Family Office',
  'Real Estate Company',
  'Holding Company',
  'Fund / Asset Manager',
  'Other Company',
  'Other Institution',
];

export const PROPERTY_INTERESTS = [
  { value: 'flipping', label: 'Property Flipping', hint: 'Buy, renovate, sell' },
  { value: 'rental', label: 'Rental Properties', hint: 'Monthly income' },
  { value: 'student', label: 'Student Housing', hint: 'High occupancy' },
  { value: 'development', label: 'New Developments', hint: 'Built from the ground up' },
  { value: 'everything', label: 'Open to Everything', hint: 'Show me it all' },
];

export const TICKET_RANGES = [
  '€100–€499', '€500–€999', '€1,000–€4,999', '€5,000–€9,999', '€10,000–€24,999', '€25,000+',
  'Not sure yet',
];

export const OBJECTIVES = [
  'Grow my capital',
  'Generate recurring income',
  'Diversify my investments',
  'Explore real estate investing',
  'A combination of these',
];

export const EXPERIENCE_LEVELS = [
  'First-time investor',
  'Some experience',
  'Experienced investor',
  'Professional / Institutional investor',
];

export const HEARD_ABOUT = [
  'Social media', 'Friend / Referral', 'Online search', 'News / Media', 'Event / Conference',
  'Business Partner', 'Other',
];
